import {createStore, applyMiddleware} from 'redux'
import createSagaMiddleware from 'redux-saga'

import RootReducer from '../Reducers/index.js'
import RootSaga from '../Sagas/RootSaga';

export default function ConfigureStore(){

    const sagaMiddleware = createSagaMiddleware()

    const store = createStore(
        RootReducer,
        applyMiddleware(sagaMiddleware)
    );
    

    sagaMiddleware.run(RootSaga)

    return store
}

